exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p {\n  color: #fff; }\n\n.footer {\n  background-color: #006595;\n  margin-bottom: -2rem; }\n\n.footer-section {\n  padding-top: 20px; }\n\n.footer-banner {\n  width: 100%; }\n\n.charity-info {\n  padding: 0 0 1rem 1rem; }\n\n.charity-info > br {\n  display: none; }\n\n@media only screen and (max-width: 768px) {\n  .charity-info > br {\n    display: unset; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasmurray/Documents/firebase-websites/CommunityAdviceNMD/src/app/components/footer/footer.component.scss
// module id = ../../../../../src/app/components/footer/footer.component.scss
// module chunks = main